export function getCookie(name) {
	const m = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
	return m ? decodeURIComponent(m[1]) : null;
}

export function getUiVersionCookie() {
	return getCookie('uiVersion'); // "v2" or null
}

export function isV2Enabled() {
	return getUiVersionCookie() === 'v2';
}

export function navigateWithForceParam(version /* 'v1' | 'v2' */) {
	const url = new URL(window.location.href);
	const current = url.searchParams.get('force');

	// Already at desired forced version – don't re-navigate
	if (current === version) return;

	url.searchParams.set('force', version);
	window.location.assign(url.toString());
}
